module.exports = __webpack_public_path__ + "img/Weapon_104.458e2f71.png";